import { CrmCheckInInteraction } from '@/types';

export const CRM_CHECK_IN_INTERACTION_LABEL_KEYS: Record<
  CrmCheckInInteraction,
  string
> = {
  [CrmCheckInInteraction.Closed]:
    'sales_portal.account_detail.check_in.tag.closed',
  [CrmCheckInInteraction.Merchandising]:
    'sales_portal.account_detail.check_in.tag.merchandizing',
  [CrmCheckInInteraction.Payment]:
    'sales_portal.account_detail.check_in.tag.payment',
  [CrmCheckInInteraction.PlacedOrder]:
    'sales_portal.account_detail.check_in.tag.placed_order',
  [CrmCheckInInteraction.Return]:
    'sales_portal.account_detail.check_in.tag.return',
  [CrmCheckInInteraction.Visited]:
    'sales_portal.account_detail.check_in.tag.visited',
};
